import React, { useState } from "react";

const KIND_LABELS = {
  ui: "In this page",
  command: "Server command",
  investigate: "Investigate",
  admin: "Admin Control",
  warning: "Important",
  info: "Context",
};

function CopyButton({ text, label }) {
  const [copied, setCopied] = useState(false);
  if (!text) return null;
  return (
    <button
      type="button"
      className="recon-fix__copy"
      onClick={() => {
        navigator.clipboard?.writeText(text).then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        });
      }}
    >
      {copied ? "Copied" : label || "Copy command"}
    </button>
  );
}

function StepActions({ step, onUiAction }) {
  if (step.kind === "ui" && step.ui_action && onUiAction) {
    const labels = {
      backfill_preview: "Preview backfill",
      backfill_apply: "Fix missing ledger rows",
      job_fix_shares_sold: "Open scheduled job options",
      cap_table_repair_preview: "Preview cap-table fix",
      cap_table_repair_apply: "Apply cap-table fix",
    };
    const label = labels[step.ui_action] || "Run action";
    return (
      <button type="button" className="history-btn history-btn--secondary recon-fix__action" onClick={() => onUiAction(step.ui_action)}>
        {label}
      </button>
    );
  }
  return null;
}

export function ReconFixPlan({ plan, onUiAction }) {
  if (!plan?.steps?.length) return null;
  return (
    <article className="recon-fix-plan">
      <header className="recon-fix-plan__head">
        <h4 className="recon-fix-plan__title">{plan.title}</h4>
        {plan.likely_cause_label ? (
          <span className="recon-fix-plan__cause">{plan.likely_cause_label}</span>
        ) : null}
      </header>
      {plan.summary ? <p className="recon-fix-plan__summary">{plan.summary}</p> : null}
      <ol className="recon-fix-steps">
        {plan.steps.map((step) => (
          <li key={step.order} className={`recon-fix-step recon-fix-step--${step.kind || "info"}`}>
            <div className="recon-fix-step__meta">
              <span className="recon-fix-step__num">{step.order}</span>
              <span className="recon-fix-step__kind">{KIND_LABELS[step.kind] || step.kind}</span>
            </div>
            <div className="recon-fix-step__body">
              <strong>{step.title}</strong>
              <p>{step.detail}</p>
              {step.command ? (
                <code className="recon-fix-step__cmd">{step.command}</code>
              ) : null}
              {step.command_apply && step.command_apply !== step.command ? (
                <code className="recon-fix-step__cmd recon-fix-step__cmd--apply">{step.command_apply}</code>
              ) : null}
              <div className="recon-fix-step__actions">
                <CopyButton text={step.command_apply || step.command} />
                <StepActions step={step} onUiAction={onUiAction} />
              </div>
            </div>
          </li>
        ))}
      </ol>
    </article>
  );
}

export default function ReconFixSteps({ plans, onUiAction }) {
  if (!plans?.length) return null;
  return (
    <section className="recon-fix" aria-labelledby="recon-fix-heading">
      <h3 id="recon-fix-heading" className="recon-section-title">
        How to fix — step by step
      </h3>
      <p className="recon-fix__intro muted small">
        Follow these steps in order for this project. Commands run inside your Backend Docker container unless noted.
      </p>
      {plans.map((plan) => (
        <ReconFixPlan key={plan.issue_code} plan={plan} onUiAction={onUiAction} />
      ))}
    </section>
  );
}
